/**
 * Structural editorial artwork: the fine grid only. The disc / ring / dot circle pattern was retired (Nov 2026).
 * Previously: solid lavender discs, 4px lavender outline rings,
 * 14px deep-lavender locator dots and a fine #EEEEEE grid, cropped off-canvas. Purely decorative: aria-hidden,
 * pointer-events none, never behind controls. Each variant is a different composition (never cloned everywhere):
 * `partner` = two interlocking rings + a small disc (agency and client), `staff` = one cropped disc + ring (restrained).
 */
export type ArtVariant = 'signin' | 'signup' | 'hero' | 'empty' | 'partner' | 'staff';

export function EditorialArt({ variant, grid = true }: { variant: ArtVariant; grid?: boolean }) {
  return (
    <span className="qm-art" data-variant={variant} aria-hidden="true">
      {grid ? <span className="qm-art__grid" /> : null}
    </span>
  );
}
